<template>
  <div style="overflow: hidden;">
    <headers :title="libraryInfo.name+'分布图'"></headers>
    <div class="map">
      <div class="current">当前在馆人数
        <!-- <p>{{onLibraryCount}}</p> -->
        <p v-for="(item,index) in totalcount" :key="index">{{item}}</p>
        <span>人</span></div>
      <!-- <baidu-map class="bm-view" :center="markerPoint" :zoom="16" >
        <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
        <bm-marker :position="markerPoint" :dragging="true" @click="infoWindowOpen">
        </bm-marker>
      </baidu-map> -->
      <div style="width: 100%;overflow: hidden;">
        <div class="echart" id="main1"></div>
      </div>
      <!-- <div class="mapwindow" @click="infoWindowClose()">
        <div class="mapTitle">{{libraryInfo.name}}</div>
        <div class="num">当前在馆人数<p>{{onLibraryCount}}</p><span>人</span></div>
        <div class="item">联系地址：{{libraryInfo.address}}</div>
        <div class="item">开放时间：{{libraryInfo.openTime}}</div>
        <div class="item">联系电话：{{libraryInfo.phone}}</div>
        <div class="qrcode">
          <img :src="libraryInfo.navigateQrCode" alt="">
          <p>扫码导航到馆</p>
        </div>
      </div> -->
    </div>

    <div class="box right top20">
      <div class="alltitle">全部书房</div>
      <div class="allMain">
        <vue-seamless-scroll :data="allLibraryName" class="seamless-warp" :class-option="classOption">

          <ul>
            <li v-for="(item, index) in allLibraryName" :key="index">{{item.name}}</li>
            <!--嘉祥嘉祥图书馆 -->
          </ul>
        </vue-seamless-scroll>
        <div class="qrcode">
          <img :src="headerInfo.phoneQrCode" alt="">
          <p>手机扫码查看<br /> 城市书房的详细</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    formatDate,
    getPreMonth
  } from '@/utils/date.js'

  const echarts = require("echarts");
  import {
    getCategoryEntityData,
  } from '@/api/anjisheng';

  
  import headers from './headers.vue';
  import {
    getAllLibraryName,
    getLibrary,
    getBookRanking
  } from "@/api/study"
  export default {
    components: {
      headers
    },
    computed: {
      classOption() {
        return {
          step: .5, // 数值越大速度滚动越快
          // limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: false, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          // openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        };
      },
    },
    data() {
      return {
        markerPoint: {
          lng: 116.59649,
          lat: 35.4082
        },
        show: false,
        allLibraryName: [],
        libraryId: null,
        libraryInfo: {},
        libraryVideo: [],
        onLibraryCount: 0,
        totalcount: [],
        animate: false,
        markPointData: [],
        headerInfo:{},
        reginJson:{}
      }
    },
    created() {

      console.log(sessionStorage.getItem("headerInfo"));

      this.headerInfo = JSON.parse(sessionStorage.getItem("headerInfo"));
      this.libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));
      console.log( this.libraryInfo.mapJsonUrl);
        console.log("==============================",this.libraryInfo.mapJson );
      this.reginJson = JSON.parse(this.libraryInfo.mapJson);
        console.log("==============================" );
      console.log(this.reginJson );

      if (this.libraryInfo) {
        this.markerPoint = {
          lng: this.libraryInfo.longitude,
          lat: this.libraryInfo.latitude
        }
      }

      if (this.$route.query.libraryId) {
        this.libraryId = this.$route.query.libraryId;
      }

      //this.getLibraryInfo();
      this.getDayEntityData();

    },
    mounted() {

      this.timers = setInterval(() => {
        this.getAllLibraryName();
        this.getDayEntityData()

      }, 5 * 60 * 1000);
      this.getAllLibraryName();
      //this.getMapChart()

    },
    methods: {
      getMapChart(mapDataList) {
            const echarts = require("echarts");

            echarts.registerMap('city', this.reginJson);
            this.chinaConfigure(mapDataList)
            //this.mapChart.setOption(this.option)
          },
          chinaConfigure(mapDataList){
            console.log(mapDataList)
            var mapChart = echarts.init(document.getElementById('main1'))
            mapChart.setOption({
                    tooltip: {},
                    geo: {
                      map: 'city',
                      zoom: 1.2,
                      roam: false,
                      itemStyle: {
                        areaColor: '#4474ec',
                        borderColor: '#fff'
                      },
                      label: {
                        show: true
                      },
                      emphasis: {
                        label: {
                          // show: false
                        },
                        itemStyle: {
                          areaColor: '#4474ec',
                        }
                      }
                    },
                    series: [
                       { // 涟漪效果
                        name: 'Top 6',
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
              
                        symbolSize: function (val) {
                            return val[2] / 200;
                        },
                        encode: {
                            value: 2
                        },
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke',
                            color: 'red',
                            number:11,
                            scale: 8
                        },
                        emphasis: {
                          scale: false
                        },
                        label: {
                            formatter: '{b}',
                            position: 'right',
                            show: false
                        },
                        itemStyle: {
                            shadowBlur: 10,
                            shadowColor: 'rgba(230, 10, 10, 1)',
                            color: 'red'
                        },
                        zlevel: 1,
                        data:mapDataList
                      }
                    ]
                  })

          },
      getDayEntityData() {
        // var libraryInfo = this.libraryInfo
        var _this = this;
        getCategoryEntityData( this.libraryInfo.entityId).then(response => {
          console.log('123123123====',response)
          var dataIn = response.Data[0].DataIn - response.Data[0].DataOut;
          if (dataIn < 0) {
            _this.onLibraryCount='0';
          } else {
            _this.onLibraryCount=dataIn+"";
          }
          // _this.onLibraryCount = (response.Data[0].DataIn - response.Data[0].DataOut)+'';
          _this.totalcount = _this.onLibraryCount.split('');

        }).catch(error => {
          console.log(error);
        });
      },
      infoWindowClose() {
        this.show = false
      },
      infoWindowOpen() {
        this.show = true
      },
      getAllLibraryName() {
        getAllLibraryName().then(response => {
          this.allLibraryName = response.data;
          var mapDataList=[]
          console.log('列表',response.data)
           if(response.data.length>0){
            response.data.forEach(function(item,index){
              //console.log(item.name)
              mapDataList.push({name:item.name,value:[item.longitude,item.latitude,1000]})
            })
          }

          //mapDataList.push({name:response.data[0].name,value:[response.data[0].longitude,response.data[0].latitude,4500]})


           //mapDataList.push({name:response.data[0].name, value: [ 117.074997,36.69216,4500]})
          // mapDataList
          //this.chinaConfigure(mapDataList)
          this.getMapChart(mapDataList)

        })
      },
      getLibraryInfo() {
        getLibrary(this.libraryId).then(response => {
          this.libraryInfo = response.data;
          console.log(response.data)
          this.markerPoint = {
            lng: this.libraryInfo.longitude,
            lat: this.libraryInfo.latitude
          }
        })
      },


    },
    destroyed() {
      clearInterval(this.timers);
    },
  }
</script>

<style scoped="scoped">
  .map {
    width: 47.6%;
    height: 833px;
    margin-top: 0px;
    margin-left: 1%;
    margin-bottom: 50px;
    position: relative;
    float: left;
  }

  .bm-view {
    width: 100%;
    height: 100%;
  }

  .mapwindow {
    background: rgba(9, 34, 99, 0.6);
    width: 424px;
    height: 558px;
    position: absolute;
    top: 40%;
    right: 30px;
    text-align: left;
    border-radius: 20px;
  }

  .mapTitle {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FBEF50;
    width: 90%;
    border-bottom: 1px solid #FBEF50;
    margin: 10px auto 0;
    line-height: 50px;
  }

  .num {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFEF1;
    margin-top: 20px;
    margin-left: 80px;
  }

  .num p {
    display: inline-block;
    background: url(../../static/numBg.png) no-repeat;
    background-size: cover;
    width: 42px;
    height: 49px;
    line-height: 49px;
    font-size: 40px;
    font-family: Century751 SeBd BT;
    font-weight: normal;
    color: #FBEF50;
    text-align: center;
    margin-left: 8px;
  }

  .num span {
    color: #00B7E9;
    margin-left: 8px;
  }

  .item {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFEF1;
    margin-top: 20px;
    margin-left: 80px;
    width: 307px;
  }

  .qrcode {
    width: 30%;
    text-align: center;
    margin: 30px auto 0;
    float: left;
  }

  .qrcode img {
    display: block;
    width: 128px;
    height: 128px;
    margin: 0 auto 20px;
  }

  .qrcode p {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFEF1;
    line-height: 36px;
  }

  .current {
    float: left;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFEF1;
    margin-top: 0px;
    margin-bottom: 34px;
    margin-left: 139px;
    position: relative;
  }

  .current p {
    display: inline-block;
    background: url(../../static/numBg.png) no-repeat;
    background-size: cover;
    width: 42px;
    height: 49px;
    line-height: 49px;
    font-size: 40px;
    font-family: Century751 SeBd BT;
    font-weight: normal;
    color: #FBEF50;
    text-align: center;
    margin-left: 8px;
  }

  .current span {
    color: #00B7E9;
    margin-left: 8px;
  }

  .box {
    background: url(../../static/minBg.png) no-repeat;
    background-size: 100% 100%;
    width: 48.75%;
    height: 359px;
    margin-top: 584px;
  }

  .alltitle {
    margin-top: 12px;
    margin-left: 20px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    text-align: left;
  }

  .allMain {
    width: 90%;
    margin: 20px auto 0;
    height: 290px;
    overflow: hidden;
  }

  .allMain::-webkit-scrollbar {
    width: 0px;
  }

  .allMain::-webkit-scrollbar-track {
    background-color: none;
  }

  .allMain::-webkit-scrollbar-thumb {
    background-color: none;
  }

  .allMain::-webkit-scrollbar-thumb:hover {
    background-color: none;
  }

  .allMain::-webkit-scrollbar-thumb:active {
    background-color: none;
  }

  .allMain ul {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .allMain li {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #8ED4F4;
    list-style: none;
    float: left;
    width: 48%;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    padding: 0;
    height: 60px;
    line-height: 60px;
    margin-right: 2%;
  }

  .anim {
    transition: all 0.5s;
    margin-top: -60px;
  }

  .seamless-warp {
    height: 290px;
    overflow: hidden;
    width: 70%;
    float: left;
  }

  .echart {
    width: 98%;
    margin: 0 auto 0;
    height: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/components/distribution.vue